import { formatCurrency } from '../../utils/categories';

/**
 * ExpenseSummary - Displays total, planned, and actual expense sums
 */
export default function ExpenseSummary({ totals }) {
  return (
    <div className="flex items-center gap-4 text-sm">
      <div>
        <span style={{ color: 'var(--color-text-muted)' }}>Total:</span>{' '}
        <span className="font-semibold" style={{ color: 'var(--color-text-primary)' }}>
          {formatCurrency(totals.total)}
        </span>
      </div>
      <div className="hidden sm:block">
        <span style={{ color: 'var(--color-category-6)' }}>Planned:</span>{' '}
        <span className="font-semibold" style={{ color: 'var(--color-text-primary)' }}>
          {formatCurrency(totals.planned)}
        </span>
      </div>
      <div className="hidden sm:block">
        <span style={{ color: 'var(--color-status-success)' }}>Actual:</span>{' '}
        <span className="font-semibold" style={{ color: 'var(--color-text-primary)' }}>
          {formatCurrency(totals.actual)}
        </span>
      </div>
    </div>
  );
}
